import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { theme, toRem } from 'design';
import { Icon } from '../Icon';

interface IButtonRetryProps {
  dataCy?: string;
  label?: string;
  isLoading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

interface IStyledIconProps {
  $isLoading?: boolean;
}

const Layout = styled.button.attrs({ type: 'button' })`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: auto;
  height: ${toRem(20)};
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(16.5)};
  line-height: 100%;
  color: ${theme.color.neutral[700]};

  &:disabled:hover {
    cursor: auto;
  }
`;

const rotate = keyframes`
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(360deg);
  }
`;

const StyledIcon = styled(Icon)<IStyledIconProps>`
  position: relative;
  top: ${toRem(-0.5)};
  margin-right: ${toRem(5.5)};
  transition: transform;
  transform: rotateZ(0deg);

  ${({ $isLoading }) =>
    $isLoading &&
    css`
      animation: ${rotate} 1500ms infinite;
      animation-timing-function: linear;
    `}
`;

const ButtonRetry: React.FC<IButtonRetryProps> = ({ dataCy = 'button-retry', label = 'Retry', isLoading, onClick, className, disabled }) => (
  <Layout className={className} onClick={onClick} disabled={disabled} data-cy={dataCy}>
    <StyledIcon icon="Retry" width={16.5} height={16.5} fill={theme.color.neutral[700]} $isLoading={isLoading} />
    {label}
  </Layout>
);

export default ButtonRetry;
